import React, {Component} from "react"
import { inject, observer } from "mobx-react";

@inject("CheckInStore")
@observer
class RiderHeader extends Component {
  render() {
    const { CheckInStore } = this.props
    return (
      <div className={`${this.props.base}__section-area`}>
        <span className="fs--medium-large" style={{ marginRight: "6px" }}>{CheckInStore.name}</span>
        <span className="fs--medium-large text--gray">{CheckInStore.isReturn ? "Return" : "Check in"}</span>
      </div>  
    )
  }
}

export default RiderHeader


// WEBPACK FOOTER //
// ./src/components/checkIn/RiderHeader.js